import React from "react";
import Button from "../../Reusable/Button";

const Soc = ({ t, link }) => {
  return (
    <div className="soc-section-holder">
      <div className="container-fluid">
        <div className="row">
          <div className="soc-section-holder-content">
            <div className="soc-section-content">
              <div className="soc-bckg-image"></div>
              <div className="soc-section-content-left">
                <div className="soc-section-content-left-items">
                  <div className="soc-section-content-left-item-1">
                    {t("socHome.text-1")}
                  </div>
                  <div className="soc-section-content-left-item soc-section-content-left-item-2">
                    {t("socHome.text-2")}
                  </div>
                  <div className="soc-section-content-left-item soc-section-content-left-item-3">
                    {t("socHome.text-3")}
                  </div>
                  <div className="soc-section-content-left-item soc-section-content-left-item-4">
                    {t("socHome.text-4")}
                  </div>
                </div>
                <div className="mob-block">
                  <Button
                    nameClass={`custom-button-gold2`}
                    text={t("home.soc.button")}
                    link={link}
                  />
                </div>
              </div>
              <div className="soc-section-content-right">
                <h2 className="des-block">{t("home.soc.title")}</h2>
                <h2 className="mob-block">{t("home.soc.title")}</h2>
                <h3>{t("home.soc.description")}</h3>
                <div className="des-block">
                  <Button
                    nameClass={`custom-button-gold2`}
                    text={t("home.soc.button")}
                    link={link}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Soc;
